export default function ContactCard({ label, value, href, icon: Icon, as: Tag = "div" }) {
  const inner = (
    <>
      <div className="mk-contact-card-icon" aria-hidden="true">
        {Icon ? <Icon size={20} strokeWidth={1.9} /> : null}
      </div>
      <div>
        <p className="mk-contact-card-label">{label}</p>
        <p className="mk-contact-card-value">{value}</p>
      </div>
    </>
  );

  if (href) {
    const external = href.startsWith("http");
    return (
      <a
        className="mk-contact-card"
        href={href}
        {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        {inner}
      </a>
    );
  }

  return <Tag className="mk-contact-card">{inner}</Tag>;
}
